
import { AbsenceComponentCode, AbsenceComponentModel } from '@/lib/api/company/configuration/payrollModule/types'

type AbsenceComponentConfig = Record<AbsenceComponentCode, {
  includeInLeave: boolean;
  isFixedComponent: boolean;
  includeInSick: boolean;
}>

const defaultAbsenceComponents : AbsenceComponentConfig = {
  "BASE": {
    includeInLeave: true,
    isFixedComponent: true,
    includeInSick: true,
  },
  "ALLOWANCE_ALL": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "ALLOWANCE_DUTY": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "ALLOWANCE_OVERTIME": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "ALLOWANCE_NIGHT": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "ALLOWANCE_EU": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "SETTLEMENT_ALL": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "SETTLEMENT_DUTY": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "SETTLEMENT_NIGHT": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "SETTLEMENT_OVERTIME": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "DUTY": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "NIGHT_WORK": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "OVERTIME": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "SETTLEMENT_EU": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "BONUS": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "BONUS_A": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "BONUS_B": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "BONUS_C": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "BONUS_D": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "COST_C": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "COST_D": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "VACATION_PAY": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
  "MINIMUM_WAGE_ADJUSTMENT": {
    includeInLeave: false,
    isFixedComponent: false,
    includeInSick: false,
  },
}

export const defaultAbsenceComponentsArray: AbsenceComponentModel[] =
  (Object.keys(defaultAbsenceComponents) as AbsenceComponentCode[])
    .map(code => ({
      code,
      includeInLeave: defaultAbsenceComponents[code].includeInLeave,
      isFixedComponent: defaultAbsenceComponents[code].isFixedComponent,
      includeInSick: defaultAbsenceComponents[code].includeInSick,
    }));

export const toAbsenceConfig = (
  absenceComponents: AbsenceComponentModel[]
): Partial<AbsenceComponentConfig> => {
  return absenceComponents.reduce<Partial<AbsenceComponentConfig>>((acc, ac) => {
    acc[ac.code] = {
      includeInLeave: ac.includeInLeave,
      isFixedComponent: ac.isFixedComponent,
      includeInSick: ac.includeInSick,
    };
    return acc;
  }, {});
};

// Merge partial absence configuration with defaults
export const mergeAbsenceConfig = (
  config: Partial<AbsenceComponentConfig> = {},
  defaultConfig: AbsenceComponentConfig = defaultAbsenceComponents,
): AbsenceComponentConfig => {
  const result: AbsenceComponentConfig = {} as AbsenceComponentConfig;

  (Object.keys({...defaultConfig}) as AbsenceComponentCode[]).forEach(code => {
    // If the user provided config for this code, use it. Otherwise use the default.
    result[code] = config[code] ?? defaultConfig[code];
  });

  return result;
};
